export function getFirebaseErrorMessage(errorCode: string): string {
  const errorMessages: Record<string, string> = {
    'auth/weak-password': 'Password must be at least 6 characters long',
    'auth/wrong-password': 'Incorrect password. Please try again',
    'auth/invalid-email': 'Please enter a valid email address',
    'auth/email-already-in-use': 'An account with this email already exists',
    'auth/user-not-found': 'No account found with this email address',
    'auth/operation-not-allowed': 'This sign-in method is not enabled',
    'auth/invalid-credential': 'Invalid email or password',
    'auth/account-exists-with-different-credential': 'An account already exists with this email',
    'auth/popup-blocked': 'Sign-in popup was blocked. Please allow popups and try again',
    'auth/popup-closed-by-user': 'Sign-in was cancelled',
    'auth/unauthorized-domain': 'This domain is not authorized for sign-in',
    'auth/too-many-requests': 'Too many failed attempts. Please try again later',
    'auth/network-request-failed': 'Network error. Please check your connection',
    'auth/missing-password': 'Please enter a password',
    'auth/missing-email': 'Please enter an email address',
  }

  return errorMessages[errorCode] || 'An error occurred. Please try again'
}
